// extracted by mini-css-extract-plugin
export default {"resetPasswordConfirmationHeader":"fRIRmS","resetPasswordConfirmationContent":"IDxIA1"};